import type { Cart } from "@packages/sdk";

import type { HallowCartRule } from "../types/enums/hallowCartRule.types";

type GetCartRuleProps = {
  cart: Cart;
  rule: HallowCartRule;
};

export const getCartRule = ({ cart, rule: ruleName }: GetCartRuleProps) =>
  cart?.promo_code?.rules.find((rule) => rule.name === ruleName);
